import { useStore } from '@nanostores/react'
import { useState } from 'react'
import { $debugAfterPaymentError } from '~/store/debug'

export function DevTools() {
  const [isOpen, setIsOpen] = useState(false)
  const debugAfterPaymentError = useStore($debugAfterPaymentError)

  return (
    <div className="fixed right-2 top-[calc(var(--safe-area-top)+8px)] z-[9999] flex flex-col items-end gap-2">
      {isOpen && (
        <div className="rounded-lg bg-black/80 p-3 text-xs text-white shadow-lg">
          <div className="mb-2 font-bold">Dev Tools</div>
          <label className="flex cursor-pointer items-center gap-2">
            <input
              type="checkbox"
              checked={debugAfterPaymentError}
              onChange={(e) =>
                $debugAfterPaymentError.set(e.currentTarget.checked)
              }
              className="h-4 w-4 cursor-pointer"
            />
            <span className="select-none">Simulate AfterPaymentError</span>
          </label>
        </div>
      )}
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex h-10 w-10 items-center justify-center rounded-full bg-black/80 text-lg text-white shadow-lg"
      >
        {isOpen ? '×' : '</>'}
      </button>
    </div>
  )
}
